import { render, staticRenderFns } from "./allocation.vue?vue&type=template&id=7ffb324e&scoped=true&"
import script from "./allocation.vue?vue&type=script&lang=js&"
export * from "./allocation.vue?vue&type=script&lang=js&"
import style0 from "./allocation.vue?vue&type=style&index=0&id=7ffb324e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ffb324e",
  null
  
)

export default component.exports